<template>
  <div class="o-chat-message mt-16">
    <div class="flex gap-4 items-center">
      <OAvatar />
      <q-chat-message
        :text="[data.comentario]"
        :sent="sender"
        bg-color="neutral-10"
        class="max-w-[600px]"
        :class="{
          'ml-auto': sender,
          'mr-auto': !sender,
        }"
      >
        <template v-if="data.obj_anexo" #default>
          <FileAnexo :file="data.obj_anexo" />
        </template>
      </q-chat-message>
    </div>
    <div
      class="flex items-center gap-6 text-pararaphy-3 mt-2"
      :class="{
        'justify-start mr-[2.25rem] md:mr-[2.25rem] flex-row-reverse': sender,
        'ml-[2.1rem] md:ml-[2.1rem]': !sender,
      }"
    >
      <span class="capitalize  text-neutral-70">{{
        data.usuario_serializado?.nome || 'Sem nome'
      }}</span>
      <span class="text-neutral-100/40 dark:text-white/10">•</span>

      <span class="text-neutral-60 dark:text-white/40"
        >{{ date.formatDate(data.data_criacao, 'DD/MM/YY') }} • -
        {{ data.data_amigavel }}
      </span>
      <!--  <OBadge text="Aguardando Reunião" class="text-headline-4 !font-semibold !py-2 !px-4 text-primary-pure" /> -->
    </div>
  </div>
</template>

<script setup>
import { date } from 'quasar'
import { inject } from 'vue'
import FileAnexo from 'components/File/FileAnexo.vue'
import OAvatar from 'components/Avatar/OAvatar.vue';
import OBadge from 'components/Badge/OBadge.vue'

const props = defineProps({
  data: Object,
})

// Pegando os valores do usuário logado pelo provider
// const {
//   data: { user },
// } = inject('context')

// Verificando se usuário enviou ou recebeu a mensagem
// const sender = props.data.usuario_criacao === user?.id
const sender = false
</script>

<style lang="sass">
@import "src/css/responsivo.sass"

.o-chat-message
  @include d(md)
    .q-message-avatar
      width: 1.5rem
      height: 1.5rem
      min-width: auto

    .q-message-text
      font-size: .75rem
      font-weight: 500 !important

    span, .tag-base-projeto
      font-size: .625rem
</style>
